import React, { useEffect, useState } from "react";
import "./leadComplianse.scss";
import Table from "./components/Table";
import Filters from "./components/Filters";
import ComplinceIcon from "../../styles/img/CompliNYC-Logo.png";
import { useCustomSearchParams } from "../../hooks/useCustomSearchParams";
import { useLeadCompliance } from "../../reactQuery/leadCompliance";
import Heading from "../../components/Heading";
import EnterSurveyResponse from "./components/Header/EnterSurveyResponse";
import DownloadAuditReport from "../Client/detail/components/Units/DownloadAuditReport";
import { downloadAuditReport } from "../../sevices/leadComplianceApi";
import { isAdmin, isSelfService } from "../../utils/helpers";
import SelfFullServiceFilter from "./components/Filters/SelfFullServiceFilter";

function LeadCompliance() {
  const [year, setYear] = useCustomSearchParams("year");
  const currentYear = new Date().getFullYear();
  const [building_id] = useCustomSearchParams("building");
  const [client] = useCustomSearchParams("client");

  const [isPastYear, setPastYear] = useState(false);
  const is_self_service = isSelfService();

  useEffect(() => {
    setPastYear(currentYear > year);
  }, [year]);

  const {
    isLoading,
    error,
    responseData,
    isError,
    refetch,
    totalRecords,
    statusCount,
    isRefetching,
  } = useLeadCompliance(`?page=1&page_size=100${year ? `&year=${year}` : ""}`);
  useEffect(() => {
    setYear("year", year || currentYear);
  }, []);
  return (
    <div>
      <Heading title="Annual Compliance">
        {isAdmin() && <SelfFullServiceFilter />}
        {  ( (isAdmin() || is_self_service) && <EnterSurveyResponse />)}
        {(isAdmin() || is_self_service) && <DownloadAuditReport
          building={building_id}
          client={client}
          downloadAuditReportPdf={downloadAuditReport}
          reportId={"mailerPdfId"}
        />}
      </Heading>

      <div className="mt-4 ticket-page">
        <Filters
          building={building_id}
          client={client}
          isFilterHide={currentYear < year && totalRecords == 0}
        />
        {currentYear < year && totalRecords == 0 ? (
          <div className="new-year-blank-compliance">
            <img src={ComplinceIcon}  />
          </div>
        ) : (
          <Table />
        )}
      </div>
    </div>
  );
}

export default LeadCompliance;
